import { createContext, useContext } from 'react';

export type ManagementMode = 'autopilot' | 'guided';

export const ManagementModeContext = createContext<ManagementMode>('guided');

export function useManagementMode() {
  return useContext(ManagementModeContext);
}
